import { Button, Col, Row, Stack } from "react-bootstrap"
import { ReactComponent as ReloadIcon } from "../svgs/refresh.svg"
import Label from "./Label"
import React from "react"

type StackAction = {
    icon: any
    onClick: () => void
    disabled?: boolean
}

type CStackProps = {
    header?: string
    children?: any
    padding?: string
    actions?: StackAction[]
    onReload?: () => void
}

const CStack: React.FC<CStackProps> = ({
    header = "",
    children = [<></>],
    padding = "15px 0",
    actions = [],
    onReload = null,
}) => {
    if (onReload) {
        actions = [...actions, {
            icon: <ReloadIcon width={20} height={20} />,
            onClick: onReload
        }]
    }
    return <div style={{ padding: padding }}>
        <Row>
            {header !== "" && <Col>
                <Label padding="10px 0" fontWeight="600" color="black">{header}</Label>
            </Col>}
            {actions.length > 0 && <Col xs={4} lg={4} ><div style={{ position: "absolute", right: "30px" }}>{
                actions.map((item: StackAction) => <>
                    <Button
                        onClick={item.onClick}
                        variant=""
                        disabled={item.disabled}
                        style={{
                            backgroundColor: "transparent",
                            margin: "5px 0px",
                            padding: "3px 3px",
                            color: "#565656",
                            fontSize: "large",
                            fontWeight: "500"
                        }
                        }>
                        {item.icon}
                    </Button>
                </>)
            }</div></Col>}
        </Row>
        <Stack gap={1}>
            {children && children.length !== undefined && children.length >= 1 && [...children]}
            {children && children.length === undefined && children}
        </Stack>
    </div>
}

export default CStack